import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import chatApi from "./api";

const initialState = {
  isLoading: false,
  userData: null,
  profileData: null,
  conversationData: null,
};

export const fetchUserData = createAsyncThunk(
  "chat/fetchUserData",
  async (id, thunk) => {
    try {
      const response = await chatApi.fetchUser(id);
      return response.data;
    } catch (error) {
      return thunk.rejectWithValue(error);
    }
  }
);

export const fetchProfileData = createAsyncThunk(
  "chat/fetchProfileData",
  async (values, thunk) => {
    try {
      const response = await chatApi.fetchProfile();
      return response?.data;
    } catch (error) {
      return thunk.rejectWithValue(error);
    }
  }
);

export const fetchConversationData = createAsyncThunk(
  "chat/fetchConversationData",
  async (values, thunk) => {
    try {
      const response = await chatApi.fetchConversation(values.profileId, values.userId);
      return response.data;
    } catch (error) {
      return thunk.rejectWithValue(error);
    }
  }
);

export const chatSlice = createSlice({
  name: "chat",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      // User Data
      .addCase(fetchUserData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.userData = action.payload;
      })
      .addCase(fetchUserData.rejected, (state) => {
        state.isLoading = false;
      })

      // profile Data
      .addCase(fetchProfileData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchProfileData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profileData = action.payload;
      })
      .addCase(fetchProfileData.rejected, (state) => {
        state.isLoading = false;
      })

      // Conversation Data
      .addCase(fetchConversationData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchConversationData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.conversationData = action.payload;
      })
      .addCase(fetchConversationData.rejected, (state) => {
        state.isLoading = false;
      })
  },
});

export const chatState = (state) => {
  return { ...state };
};
